import { render, staticRenderFns } from "./ProductPriceMatrixRow.vue?vue&type=template&id=79e9d86a&scoped=true&"
import script from "./ProductPriceMatrixRow.vue?vue&type=script&lang=js&"
export * from "./ProductPriceMatrixRow.vue?vue&type=script&lang=js&"
import style0 from "./ProductPriceMatrixRow.vue?vue&type=style&index=0&id=79e9d86a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e9d86a",
  null
  
)

export default component.exports